import logo from '../assets/icon.png';

const images = {
    logo
};

export default images;